<template>
  <div>
    <el-dialog title="编辑vps" :visible.sync="dialogVisible" :before-close="cancel">
      <el-form :model="form" ref="form" label-position="left" label-width="120px">
        <el-form-item label="云主机名" prop="cloud_server">
          <el-input style="width:350px"  v-model="form.cloud_server" clearable></el-input>
        </el-form-item>        
        <el-form-item label="供应商" prop="suply">
          <el-input style="width:350px" v-model="form.suply" clearable></el-input>
        </el-form-item>  
        <el-form-item label="运营商" prop="isp_addr">
          <el-input style="width:350px" v-model="form.isp_addr" clearable></el-input>
        </el-form-item>     
        <el-form-item label="省份" prop="province">
          <el-input style="width:350px" v-model="form.province" clearable></el-input>
        </el-form-item>   
        <el-form-item label="地区" prop="city">
          <el-input style="width:350px" v-model="form.city" clearable></el-input>
        </el-form-item>             
        <el-form-item label="手机号" prop="mobile">
          <el-input style="width:350px" v-model="form.mobile" clearable></el-input>
        </el-form-item>        
        <el-form-item label="指定用户" prop="user">
          <el-input style="width:350px" v-model="form.user" clearable></el-input>
        </el-form-item>      
        <el-form-item label="手机卡流量" prop="flow">
          <el-input style="width:350px" v-model="form.flow" clearable></el-input>
        </el-form-item>            
        <el-form-item label="过期时间" prop="flow_date">
            <el-date-picker
                style="width:350px"
                v-model="form.flow_date"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="timestamp"
                type="datetime"
                placeholder="选择日期时间"
            >
            </el-date-picker>
        </el-form-item>        
        <el-form-item label="备注" prop="tag">
          <el-input style="width:350px" v-model="form.tag" clearable></el-input>
        </el-form-item>        
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { dynamic_vps_edit } from "@/request/api.js";
export default {
    created(){
      this.form={...this.dialogData}
    },
    props:{
        dialogData: {
            type: Object,
            default: {},
        },
        dialogVisible:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return {
            form:{},
        }
    },
    methods:{
        cancel(){
            this.$emit('update:dialogVisible',false)
        },
        submit(){
          // let obj = {}
          let obj = {...this.form}
          obj.id=this.form._id;
          if(obj.flow_date>9999999999){
            obj.flow_date=obj.flow_date/1000
          }
          delete obj._id       
          if(this.form.user){
            obj.vip=2
          }
          dynamic_vps_edit(obj).then(
            (res) => {
              if (res.status == 0) {
                this.$message.success(res.detail);
                this.$emit('freshData')
                this.$emit('update:dialogVisible',false)

              }
            }
          );
        }
    }
}
</script>

<style lang = "less" scoped>
.el-input {
    width: 400px;
}
</style>